import { withI18n } from 'react-i18next';
import Modal from './Modal';

export default withI18n()(Modal);
